import { Component } from '@angular/core';
import {SubscribeComponent} from "../../common/subscribe/subscribe.component";

@Component({
  selector: 'app-satzung',
  standalone: true,
    imports: [
        SubscribeComponent
    ],
  templateUrl: './satzung.component.html',
  styleUrl: './satzung.component.scss'
})
export class SatzungComponent {

}
